<ng-container *ngIf="!!slice">
  <ng-container *ngIf="link === null; then content else contentInLink"></ng-container>
</ng-container>

<ng-template #content>
  <ng-container *ngComponentOutlet="slice | dynamicIdtComponentResolution: 'render';
    ndcDynamicInputs: {
      slice: slice
    };"></ng-container>
</ng-template>

<ng-template #contentInLink>
  <render-link
    lazyLoad
    [piece]="slice"
    [link]="link"
    [lang]="lang$ | async"
    (renderLinkEvent)="onRenderLinkClick($event)"
    (lazyLoad)="onRenderComponent()">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </render-link>
</ng-template>
